import {TableSettings} from "../../../tableSettings";

export const batchRecognitionReportTable: TableSettings = {
  tableVersion: 10019,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '200px',
  flexResizer: true,

  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.2, headerFilterType:'None', },
    { Header: 'Select', accessor: 'selected', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType:'None', },
    { Header: 'Recog Date', accessor: 'recogDate', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.9, headerFilterType:'Date', },
    { Header: 'Billing First', accessor: 'firstDate', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.9, headerFilterType:'Date', },
    { Header: 'ETD/ETA(F.ETA)', accessor: 'etdeta', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.9, headerFilterType:'Date', },
    { Header: 'OP Type', accessor: 'mblType', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.2, headerFilterType:'TextSelect', },
    { Header: 'BR', accessor: 'branch', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType:'TextSelect', },
    { Header: '+', accessor: 'closed', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType:'TextSelect', },
    { Header: 'Ref. #', accessor: 'mblRefNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7, headerFilterType:'TextBegin', },

    { Header: 'HBL(s)', accessor: 'hblCnt', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.5, headerFilterType:'TextSelect', },
    { Header: 'Customer', accessor: 'hblCustomer', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.5, headerFilterType:'TextBegin', },

    { Header: 'Def. Sales', accessor: 'defSales', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.4, headerFilterType:'Number', },
    { Header: 'Def. Cost', accessor: 'defCost', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.4, headerFilterType:'Number', },
    { Header: 'Def. Agent Sales', accessor: 'defASales', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.4, headerFilterType:'Number', },
    { Header: 'Def. Agent Cost', accessor: 'defACost', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.4, headerFilterType:'Number', },

    { Header: 'Inv', accessor: 'invPaid', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType:'TextSelect', },
    { Header: 'Bil', accessor: 'billPaid', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType:'TextSelect', },
    { Header: 'CrDb', accessor: 'crDbPaid', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.3, headerFilterType:'TextSelect', },

    { Header: 'Est. Margin', accessor: 'estMargin', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.4, headerFilterType:'Number', },

    { Header: 'Prep. By', accessor: 'hblPrepBy', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.4, headerFilterType:'TextBegin', },
    { Header: 'Salesperson', accessor: 'hblSalesperson', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5.4, headerFilterType:'TextBegin', },

   
    { Header: 'Status', accessor: 'status', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.6, headerFilterType:'None', },
    { Header: 'View Detail', accessor: 'action', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2, headerFilterType:'None', },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 1.50, headerFilterType:'None', },
  ]
};

export const CompanyAddressLabelReportTable: TableSettings = {
  tableVersion: 10005,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '200px',
  flexResizer: true,

  columns: [
    { Header: '', accessor: 'indicator', resizable: false, sortable: false, visible: true, hideTooltip: true, initialWidthPercentage: 7, },
    { Header: 'Company Name', accessor: 'text', resizable: false, sortable: false, visible: true, hideTooltip: true, initialWidthPercentage: 70, },
    { Header: 'Count', accessor: 'intValue', resizable: false, sortable: false, visible: true, hideTooltip: true, initialWidthPercentage: 19, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, hideTooltip: true, initialWidthPercentage: 4, }
  ]
};

export const periodClosingReportTable: TableSettings = {
  tableVersion: 1002,
  overflowX: 'hidden',
  overflowY: 'auto',
  
  height: '200px',
  flexResizer: true,

  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5,
    },
    {
      Header: 'Date',
      accessor: 'date',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 23,
    },
    {
      Header: 'Closed Period',
      accessor: 'closedPeriod',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 23,
    },
    {
      Header: 'User',
      accessor: 'userId',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 24,
    },
    {
      Header: 'Remark',
      accessor: 'remark',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 24,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.00,
    },
  ]
};

export const customerPaymentList: TableSettings = {
  tableVersion: 10059,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: []
};

export const allPaymentList: TableSettings = {
  tableVersion: 10060,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: []
};


export const agentPaymentList: TableSettings = {
  tableVersion: 10060,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: []
};

export const billPaymentList: TableSettings = {
  tableVersion: 10058,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: []
};

export const ccPaymentList: TableSettings = {
  tableVersion: 10055,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: []
};

export const customerPaymentContainerDetails1: TableSettings = {
  tableVersion: 1025,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '65px',
  flexResizer: true,

  columns: [
    {
      Header: 'Account Name',
      accessor: 'glDescription',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 34.21,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Increase',
      accessor: 'increase',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Decrease',
      accessor: 'decrease',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
  ]
};

export const customerPaymentContainerDetails2: TableSettings = {
  tableVersion: 1058,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '221px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2,
      headerFilterType: 'None',
    },
    {
      Header: 'Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
     initialWidthPercentage: 6,
     headerFilterType: 'Date',
    },
    {
      Header: 'S.Date',
      accessor: 'schDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6,
      headerFilterType: 'Date',
    },
    {
      Header: 'Due Date',
      accessor: 'dueDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6,
      headerFilterType: 'Date',
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: true,
      sortable: false,
      visible: true,
     initialWidthPercentage: 3.25,
     headerFilterType: 'TextSelect',
    },
    {
      Header: 'Bill #',
      accessor: 'invNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.5,
      headerFilterType: 'TextBegin',
    },
    {
      Header: 'Type',
      accessor: 'stbName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.25,
      headerFilterType:'TextSelect',
    },
    {
      Header: 'C',
      accessor: 'confirmed',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
      headerFilterType:'None',
    },
    {
      Header: 'Account Name',
      accessor: 'accountName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.25,
      headerFilterType: 'TextSelect',
    },
    {
      Header: 'Customer',
      accessor: 'entityName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.5,
      headerFilterType: 'TextBegin',
    },
    {
      Header: 'Ref. #',
      accessor: 'refNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.25,
      headerFilterType: 'TextBegin',
    },
    {
      Header: 'B/L #',
      accessor: 'hblNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.25,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.25,
      headerFilterType:'TextSelect',
    },
    {
      Header: 'Bill Amount',
      accessor: 'invAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7,
      headerFilterType: 'Number',
    },
    {
      Header: 'Due Amount',
      accessor: 'dueAmount',
      resizable: true,
      sortable: false,
      visible: true,
     initialWidthPercentage: 7,
     headerFilterType: 'Number',
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7,
      headerFilterType: 'Number',
    },
    {
      Header: 'Select',
      accessor: 'isSelect',
      resizable: false,
      sortable: false,
      visible: true,
     initialWidthPercentage: 2,
     headerFilterType: 'None',
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
      headerFilterType:'None',
    },
  ]
};

export const customerPaymentContainerDetails3: TableSettings = {
  tableVersion: 1019,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5,
    },
    {
      Header: 'Accural Date',
      accessor: 'postDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7, 
    },
    {
      Header: 'Check #',
      accessor: 'checkNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10, 
    },
    {
      Header: 'Customer',
      accessor: 'billToName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Received From',
      accessor: 'paidToName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    // {
    //   Header: 'Draft',
    //   accessor: 'isDraft',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 5.26,
    // },
    {
      Header: 'Bank',
      accessor: 'bankName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Deposit Amount',
      accessor: 'totalAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
    {
      Header: 'Ex. Rate',
      accessor: 'exRate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },
    {
      Header: 'Payment Type',
      accessor: 'paymentType',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7,
    },
    {
      Header: '',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.5,
    },
  ]
};

export const customerPaymentContainerDetails4: TableSettings = {
  tableVersion: 1028,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '328px',
  flexResizer: true,

  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3, },
    { Header: 'Account Code', accessor: 'glNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: 'Account Description', accessor: 'othRefNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 20, },
    { Header: 'Description', accessor: 'description', resizable: false, sortable: false, visible: true, initialWidthPercentage: 32, },
    { Header: 'CUR', accessor: 'currency', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5, },
    { Header: 'Curr. Balance', accessor: 'balance', resizable: false, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: 'New Balance', accessor: 'newBalance', resizable: false, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: 'Amount', accessor: 'amount', resizable: false, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 1, },
  ]
};

export const agentPaymentContainerDetails1: TableSettings = {
  tableVersion: 1025,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '65px',
  flexResizer: true,

  columns: [
    {
      Header: 'Account Name',
      accessor: 'glDescription',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 34.21,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Increase',
      accessor: 'increase',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Decrease',
      accessor: 'decrease',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
  ]
};

export const agentPaymentContainerDetails2: TableSettings = {
  tableVersion: 1048,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '221px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
      headerFilterType:'None',
    },
    {
      Header: 'Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.01,
      headerFilterType:'Date',
    },
    {
      Header: 'S.Date',
      accessor: 'schDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.01,
      headerFilterType:'Date',
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
      headerFilterType:'TextSelect',
    },
    {
      Header: 'Bill #',
      accessor: 'invNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
      headerFilterType:'TextBegin',
    },
    {
      Header: 'C',
      accessor: 'confirmed',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
      headerFilterType:'None',
    },
    {
      Header: 'Type',
      accessor: 'stbName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.50,
      headerFilterType:'TextSelect',
    },
    {
      Header: 'Account Name',
      accessor: 'accountName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.52,
      headerFilterType:'TextSelect',
    },
    {
      Header: 'Customer',
      accessor: 'entityName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.53,
      headerFilterType:'TextBegin',
    },
    {
      Header: 'Ref. #',
      accessor: 'refNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.27,
      headerFilterType:'TextBegin',
    },
    {
      Header: 'B/L #',
      accessor: 'hblNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.27,
      headerFilterType:'TextBegin',
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.5,
      headerFilterType:'TextSelect',
    },
    {
      Header: 'Bill Amount',
      accessor: 'invAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.39,
      headerFilterType:'Number',
    },
    {
      Header: 'Due Amount',
      accessor: 'dueAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.39,
      headerFilterType:'Number',
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.39,
      headerFilterType:'Number',
    },
    {
      Header: 'Select',
      accessor: 'isSelect',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.38,
      headerFilterType:'None',
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
      headerFilterType:'None',
    },
  ]
};

export const agentPaymentContainerDetails3: TableSettings = {
  tableVersion: 1012,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5,
    },
    {
      Header: 'Accural Date',
      accessor: 'postDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7,
    },
    {
      Header: 'Check #',
      accessor: 'checkNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
    {
      Header: 'Customer',
      accessor: 'billToName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Received From',
      accessor: 'paidToName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    // {
    //   Header: 'Draft',
    //   accessor: 'isDraft',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 5.26,
    // },
    {
      Header: 'Bank',
      accessor: 'bankName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Deposit Amount',
      accessor: 'totalAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
    {
      Header: 'Ex. Rate',
      accessor: 'exRate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },
    {
      Header: 'Payment Type',
      accessor: 'paymentType',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7,
    },
    {
      Header: '',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.5,
    },
  ]
};

export const billPaymentContainerDetails1: TableSettings = {
  tableVersion: 1025,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '66px',
  flexResizer: true,

  columns: [
    {
      Header: 'Account Name',
      accessor: 'glDescription',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 34.21,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Increase',
      accessor: 'increase',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
    {
      Header: 'Decrease',
      accessor: 'decrease',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.42,
    },
  ]
};

export const billPaymentContainerDetails2: TableSettings = {
    tableVersion: 1077,
    overflowX: 'hidden',
    overflowY: 'scroll',

    height: '221px',
    flexResizer: true,

    columns: [
        {
            Header: '#',
            accessor: 'indicator',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 2,
            headerFilterType: 'None',
        },
        {
            Header: 'Date',
            accessor: 'postDate',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 6,
            headerFilterType: 'Date',
        },
        {
            Header: 'S.Date',
            accessor: 'schDate',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 6,
            headerFilterType: 'Date',
        },
        {
            Header: 'Due Date',
            accessor: 'dueDate',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 6,
            headerFilterType: 'Date',
        },
        {
            Header: 'BR',
            accessor: 'branch',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 3.25,
            headerFilterType: 'TextSelect',
        },
        {
            Header: 'Bill #',
            accessor: 'invNo',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 8.25,
            headerFilterType: 'TextBegin',
        },
        {
            Header: 'Type',
            accessor: 'stbName',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 3.25,
            headerFilterType: 'TextSelect',
        },
        {
            Header: 'B',
            accessor: 'block',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 1.75,
            headerFilterType: 'None',
        },
        {
            Header: 'C',
            accessor: 'confirmed',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 1.75,
            headerFilterType: 'None',
        },
        {
            Header: 'E',
            accessor: 'isEPay',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 1.75,
            headerFilterType: 'None',
        },
        {
            Header: 'Account Name',
            accessor: 'accountName',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 9,
            headerFilterType: 'TextSelect',
        },
        {
            Header: 'Vendor',
            accessor: 'entityName',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 8.5,
            headerFilterType: 'TextBegin',
        },
        {
            Header: 'Ref. #',
            accessor: 'refNo',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 7.25,
            headerFilterType: 'TextBegin',
        },
        {
          Header: 'B/L #',
          accessor: 'hblNo',
          resizable: true,
          sortable: false,
          visible: true,
          initialWidthPercentage: 7.25,
        },
        {
            Header: 'CUR',
            accessor: 'currency',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 3.25,
            headerFilterType: 'TextSelect',
        },
        {
            Header: 'Bill Amount',
            accessor: 'invAmount',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 7,
            headerFilterType: 'Number',
        },
        {
            Header: 'Due Amount',
            accessor: 'dueAmount',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 7,
            headerFilterType: 'Number',
        },
        {
            Header: 'Amount',
            accessor: 'amount',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 7,
            headerFilterType: 'Number',
        },
        {
            Header: 'Select',
            accessor: 'isSelect',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 2,
            headerFilterType: 'None',
        },
        {
            Header: '',
            accessor: 'scroll',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 1.75,
            headerFilterType: 'None',
        },
    ]
};

export const billPaymentContainerDetails3: TableSettings = {
  tableVersion: 1033,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5, //2.63,
    },
    {
      Header: 'Accural Date',
      accessor: 'postDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7, //8,
    },
    {
      Header: 'Check #',
      accessor: 'checkNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10, //11.07,
    },
    {
      Header: 'Vendor',
      accessor: 'billToName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17, //18,
    },
    {
      Header: 'Pay To',
      accessor: 'paidToName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17, //18,
    },
    // {
    //   Header: 'Draft',
    //   accessor: 'isDraft',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 5.26,
    // },
    {
      Header: 'Bank',
      accessor: 'bankName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17, //17.6,
    },
    {
      Header: 'Paid Amount',
      accessor: 'totalAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
    {
      Header: 'Ex. Rate',
      accessor: 'exRate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6, //7,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4, //5,
    },
    {
      Header: 'Payment Type',
      accessor: 'paymentType',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7, //8,
    },
    {
      Header: '',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.5,
    },
  ]
};

export const billPaymentContainerDetails4: TableSettings = {
  tableVersion: 1024,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '328px',
  flexResizer: true,

  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3, },
    { Header: 'Account Code', accessor: 'glNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: 'Account Description', accessor: 'othRefNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 20, },
    { Header: 'Description', accessor: 'description', resizable: false, sortable: false, visible: true, initialWidthPercentage: 32, },
    { Header: 'CUR', accessor: 'currency', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5, },
    { Header: 'Curr. Balance', accessor: 'balance', resizable: false, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: 'New Balance', accessor: 'newBalance', resizable: false, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: 'Amount', accessor: 'amount', resizable: false, sortable: false, visible: true, initialWidthPercentage: 9, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 1, },
  ]
};

export const ccPaymentContainerDetails2: TableSettings = {
    tableVersion: 1019,
    overflowX: 'hidden',
    overflowY: 'scroll',

    height: '229px',
    flexResizer: true,

    columns: [
        {
            Header: '#',
            accessor: 'indicator',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 2.63,
            headerFilterType: 'None',
        },
        {
            Header: 'Date',
            accessor: 'postDate',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 6.58,
            headerFilterType: 'Date',
        },
        {
            Header: 'S.Date',
            accessor: 'schDate',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 6.58,
            headerFilterType: 'Date',
        },
        {
            Header: 'BR',
            accessor: 'branch',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 4.85,
            headerFilterType: 'TextSelect',
        },
        {
            Header: 'Bill #',
            accessor: 'invNo',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 8.78,
            headerFilterType: 'TextBegin',
        },
        {
            Header: 'Type',
            accessor: 'stbName',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 4.85,
            headerFilterType: 'TextSelect',
        },
        {
            Header: 'B',
            accessor: 'block',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 1.75,
            headerFilterType: 'None',
        },
        {
            Header: 'C',
            accessor: 'confirmed',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 1.75,
            headerFilterType: 'None',
        },
        {
            Header: 'Account Name',
            accessor: 'accountName',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 11.06,
            headerFilterType: 'TextSelect',
        },
        {
            Header: 'Ref. #',
            accessor: 'refNo',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 8.70,
            headerFilterType: 'TextBegin',
        },
        {
            Header: 'B/L #',
            accessor: 'hblNo',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 8.70,
            headerFilterType: 'TextBegin',
        },
        {
            Header: 'CUR',
            accessor: 'currency',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 4.04,
            headerFilterType: 'TextSelect',
        },
        {
            Header: 'Bill Amount',
            accessor: 'invAmount',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 7.89,
            headerFilterType: 'Number',
        },
        {
            Header: 'Due Amount',
            accessor: 'dueAmount',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 7.89,
            headerFilterType: 'Number',
        },
        {
            Header: 'Amount',
            accessor: 'amount',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 7.89,
            headerFilterType: 'Number',
        },
        {
            Header: 'Select',
            accessor: 'isSelect',
            resizable: true,
            sortable: false,
            visible: true,
            initialWidthPercentage: 4.04,
            headerFilterType: 'None',
        },
        {
            Header: '',
            accessor: 'scroll',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 2.02,
            headerFilterType: 'None',
        },
    ]
};

export const ccPaymentContainerDetails3: TableSettings = {
  tableVersion: 1048,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Accrual Date',
      accessor: 'accrualDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.7,
    },
    {
      Header: 'CC Ref. #',
      accessor: 'ccRefNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.94,
    },
    {
      Header: 'Vendor',
      accessor: 'billToName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 25.91,
    },

    {
      Header: 'Credit Card',
      accessor: 'creditCardName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 22.49,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.04,
    },
    {
      Header: 'Ex. Rate',
      accessor: 'exRate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.09,
    },
    {
      Header: 'Paid Amount',
      accessor: 'totalAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.5,
    },
    {
      Header: '',
      accessor: 'commands',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.7,
    },
  ]
};

export const customerPaymentMemoList: TableSettings = {
  tableVersion: 1004,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    {
      accessor: 'customerName',
      Header: 'Customer',
      visible: true,
      width: 200,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      defaultColumnFocus: true
    },
    {
      accessor: 'contact',
      Header: 'Contact',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'phone',
      Header: 'Phone',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'followUp',
      Header: 'Follow Up',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'currency',
      Header: 'CUR',
      visible: true,
      width: 60,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'lastPaidAmt',
      Header: 'Last Paid Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'checkNo',
      Header: 'Paid Check #',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'lastPaidDate',
      Header: 'Paid Date',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'salesRep',
      Header: 'Sales Rep',
      visible: true,
      width: 95,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'groupId',
      Header: 'Group',
      visible: true,
      width: 60,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'terms',
      Header: 'Terms',
      visible: true,
      width: 60,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'avgAging',
      Header: 'Avg Aging',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'currentBal',
      Header: 'Current Balance',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'curCnt',
      Header: 'Current Count',
      visible: true,
      width: 70,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'pastDue',
      Header: 'Past Due Amount',
      visible: true,
      width: 90,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'pastDueCnt',
      Header: 'Past Due Count',
      visible: true,
      width: 90,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'days15',
      Header: '15 Days',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'days30',
      Header: '30 Days',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'days45',
      Header: '45 Days',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'days60',
      Header: '60 Days',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'days90',
      Header: '90 Days',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'over90',
      Header: 'Over',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'balance',
      Header: 'Total Balance',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'memo',
      Header: 'Last Memo Title',
      visible: true,
      width: 300,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const generalInvoiceList: TableSettings = {
  tableVersion: 1022,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
  ]
};

export const generalBillList: TableSettings = {
  tableVersion: 1027,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,
  alternateRows: true,
  columns: [
  ]
};

export const depositClearTable: TableSettings = {
  tableVersion: 10040,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,

  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Type', accessor: 'type', resizable: false, sortable: true, visible: true, initialWidthPercentage: 4.03, },
    { Header: 'Customer', accessor: 'customerName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 19.23, },
    { Header: 'Received From', accessor: 'receivedFromName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 19.23, },
    { Header: 'Check #', accessor: 'checkNo', resizable: false, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'CUR', accessor: 'currency', resizable: false, sortable: true, visible: true, initialWidthPercentage: 5.12, },
    { Header: 'Items', accessor: 'items', resizable: false, sortable: true, visible: true, initialWidthPercentage: 4.69, },
    { Header: 'Amount', accessor: 'amount', resizable: false, sortable: true, visible: true, initialWidthPercentage: 11.53, },
    { Header: 'Deposit', accessor: 'isSelected', resizable: false, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const checkClearTable: TableSettings = {
  tableVersion: 10043,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,

  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Type', accessor: 'type', resizable: false, sortable: true, visible: true, initialWidthPercentage: 4.03, },
    { Header: 'Vendor', accessor: 'customerName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 19.23, },
    { Header: 'Pay To', accessor: 'receivedFromName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 19.23, },
    { Header: 'Check #', accessor: 'checkNo', resizable: false, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'CUR', accessor: 'currency', resizable: false, sortable: true, visible: true, initialWidthPercentage: 5.12, },
    { Header: 'Items', accessor: 'items', resizable: false, sortable: true, visible: true, initialWidthPercentage: 3.69, },
    { Header: 'Amount', accessor: 'amount', resizable: false, sortable: true, visible: true, initialWidthPercentage: 11.53, },
    { Header: 'Check', accessor: 'isSelected', resizable: false, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const creditCardClearTable: TableSettings = {
  tableVersion: 10039,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,
  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'Vendor', accessor: 'vendorName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 33.33, },
    { Header: 'CC Ref. #', accessor: 'ccRefNo', resizable: false, sortable: true, visible: true, initialWidthPercentage: 14.10, },
    { Header: 'CUR', accessor: 'currency', resizable: false, sortable: true, visible: true, initialWidthPercentage: 5.12, },
    { Header: 'Items', accessor: 'items', resizable: false, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: 'Amount', accessor: 'amount', resizable: false, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'CC Clear', accessor: 'isSelected', resizable: false, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const bankReconList: TableSettings = {
  tableVersion: 10042,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
  ]
};

export const bankReconTable: TableSettings = {
  tableVersion: 1014,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '455px',
  flexResizer: true,

  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 5, },
    { Header: 'Date', accessor: 'postDate', resizable: false, sortable: false, visible: true, initialWidthPercentage: 11, },
    { Header: 'Check #', accessor: 'checkNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 15, },
    { Header: 'Type', accessor: 'paymentType', resizable: false, sortable: false, visible: true, initialWidthPercentage: 6.5, },
    { Header: 'Amount (USD)', accessor: 'amount', resizable: false, sortable: false, visible: true, initialWidthPercentage: 15, },
    { Header: 'Customer', accessor: 'mDesc', resizable: false, sortable: false, visible: true, initialWidthPercentage: 22, },
    { Header: 'Received From', accessor: 'mDesc2', resizable: false, sortable: false, visible: true, initialWidthPercentage: 22, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.5, },
  ]
};

export const bankTransferList: TableSettings = {
  tableVersion: 1013,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'postDate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'fBankName',
      Header: 'From Bank',
      visible: true,
      width: 120,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'fCurrency',
      Header: 'CUR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'tBankName',
      Header: 'To Bank',
      visible: true,
      width: 120,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'tCurrency',
      Header: 'CUR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'tAmount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2Id',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1Id',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const prepaidExpenseAdjustmentList: TableSettings = {
  tableVersion: 1011,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    {
      accessor: 'postdate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'branch',
      Header: 'BR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'vendorname',
      Header: 'Vendor',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'gldescription',
      Header: 'Account Name',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'decription',
      Header: 'Description',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const prepaidExpenseAdjustmentTable: TableSettings = {
  tableVersion: 10052,
  overflowX: 'hidden',
  // overflowY: 'scroll',
  overflowY: 'hidden',
  height: '65px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Date',
      accessor: 'postDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'Account Code',
      accessor: 'glDescription',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 26.3,
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 37.76,
    },
    {
      Header: 'Balance',
      accessor: 'expense',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.64,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.64,
    },
    // {
    //   Header: '',
    //   accessor: 'scroll',
    //   resizable: false,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 1.75,
    // },
  ]
};

export const paymentPrepTable: TableSettings = {
  tableVersion: 10021,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '360px',
  flexResizer: false,

  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Vendor',
      accessor: 'vendorName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.57,
    },
    {
      Header: 'Description',
      accessor: 'desc',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 28.31,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Amount',
      accessor: 'amtDesc',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.71,
    },
    {
      Header: 'Advance Payment',
      accessor: 'hasAdvance',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.2,
    },
    {
      Header: 'Bank & Account',
      accessor: 'bankAndAcct',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.77,
    },
    {
      Header: 'Select',
      accessor: 'isSelect',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.8,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};

export const paymentPrepList: TableSettings = {
  tableVersion: 1006,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'void',
      Header: 'V',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'postdate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'branch',
      Header: 'BR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'vendorname',
      Header: 'Vendor',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'gldescription',
      Header: 'Account Name',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'decription',
      Header: 'Description',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const payrollSummaryList: TableSettings = {
  tableVersion: 1011,
  overflowX: 'scroll',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'payrollDate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'refNo',
      Header: 'Ref. #',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'branch',
      Header: 'BR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'grossAmt',
      Header: 'Gross Salary',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'payableFedTax',
      Header: 'Payroll Tax (Fed)',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'fedTaxPaid',
      Header: 'Paid',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'payableStateTax',
      Header: 'Payroll Tax (State)',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'stateTaxPaid',
      Header: 'Paid',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'payableNetSalary',
      Header: 'Net Salary',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'netSalaryPaid',
      Header: 'Paid',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'addTaxAmt',
      Header: 'Additional Tax',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'addTaxPaid',
      Header: 'Paid',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'addPayAmt',
      Header: 'Salary Deduction',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'addPayPaid',
      Header: 'Paid',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    // {
    //   accessor: 'voidInputDate',
    //   Header: 'Void Date',
    //   visible: true,
    //   width: 75,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'date'
    // },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'modifiedAt',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'modifiedBy',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'createdBy',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const payroll2List: TableSettings = {
  tableVersion: 1014,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
  ]
};

export const payrollSummaryAmountsTable: TableSettings = {
  tableVersion: 10045,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '200px',
  flexResizer: false,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      width: 30,
    },
    {
      Header: 'Department',
      accessor: 'departmentName',
      resizable: false,
      sortable: false,
      visible: true,
      width: 110,
    },
    {
      Header: 'Gross Salaries & Wages',
      accessor: 'grossAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 140,
    },
    // {
    //   Header: 'Federal Payroll Tax (Corporate)',
    //   accessor: 'fedPRTaxAmt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   width: 140,
    // },
    // {
    //   Header: 'State Payroll Tax (Corporate)',
    //   accessor: 'stePRTaxAmt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   width: 140,
    // },
    // {
    //   Header: 'MEDICAL INSURANCE (Withholding)',
    //   accessor: 'expOption1Amt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 12.28,
    // },
    // {
    //   Header: 'DENTAL INSURANCE (Withholding)',
    //   accessor: 'expOption2Amt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 12.28,
    // },
    // {
    //   Header: '401K PLAN (Withholding)',
    //   accessor: 'expOption3Amt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 12.28,
    // },
    // {
    //   Header: '(*) (Withholding)',
    //   accessor: 'expOption4Amt',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 12.28,
    // },
    // {
    //   Header: '',
    //   accessor: 'scroll',
    //   resizable: true,
    //   sortable: false,
    //   visible: true,
    //   initialWidthPercentage: 1.75,
    // },
  ]
};

export const payrollSummaryByEntityTable: TableSettings = {
  tableVersion: 1007,
  overflowX: 'hidden',
  overflowY: 'hidden',
  height: '200px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.5,
    },
    {
      Header: 'Payable',
      accessor: 'payable',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Entity',
      accessor: 'entity',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 27,
    },
    {
      Header: 'Corporate',
      accessor: 'corporate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16,
    },
    {
      Header: 'Withholding',
      accessor: 'withholding',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16,
    },
    {
      Header: 'Total',
      accessor: 'total',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16,
    },
    {
      Header: 'Paid',
      accessor: 'paid',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.5,
    }
  ]
};

export const payroll2GroupTable: TableSettings = {
  tableVersion: 10007,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '100px',

  flexResizer: false,
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      width: 30,
    },
    {
      Header: 'Payroll Group',
      accessor: 'groupName',
      resizable: false,
      sortable: false,
      visible: true,
      width: 90,
    },
    {
      Header: 'Gross Salary',
      accessor: 'salaryAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 90,
    },
    {
      Header: 'Detail',
      accessor: 'isView',
      resizable: false,
      sortable: false,
      visible: true,
      width: 60,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      width: 20,
  },
  ]
};

export const payroll2AmountsTable: TableSettings = {
  tableVersion: 10053,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '430px',

  flexResizer: false,
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      width: 30,
    },
    {
      Header: 'Group',
      accessor: 'groupName',
      resizable: false,
      sortable: false,
      visible: true,
      width: 60,
    },
    {
      Header: 'Items',
      accessor: 'billingCode',
      resizable: false,
      sortable: false,
      visible: true,
      width: 160,
    },
    {
      Header: 'Withholding',
      accessor: 'withholdAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 90,
    },
    {
      Header: 'Corporate',
      accessor: 'corporateAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 90,
    },
    {
      Header: 'Entity',
      accessor: 'entityName',
      resizable: false,
      sortable: false,
      visible: true,
      width: 140,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      width: 20,
    },
  ]
};

export const payroll2ByEntityTable: TableSettings = {
  tableVersion: 1021,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '200px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      width: 30,
    },
    {
      Header: 'Items',
      accessor: 'itemName',
      resizable: false,
      sortable: false,
      visible: true,
      width: 180,
    },
    {
      Header: 'Withholding',
      accessor: 'withholdAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 80,
    },
    {
      Header: 'Corporate',
      accessor: 'corporateAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 80,
    },
    {
      Header: 'Amount',
      accessor: 'totalAmt',
      resizable: false,
      sortable: false,
      visible: true,
      width: 80,
    },
    {
      Header: 'Payable To',
      accessor: 'payableEntityName',
      resizable: false,
      sortable: false,
      visible: true,
      width: 120,
    },
    {
      Header: 'Bank',
      accessor: 'bank',
      resizable: false,
      sortable: false,
      visible: true,
      width: 150,
    },
    {
      Header: 'ETF Ref #',
      accessor: 'checkNo',
      resizable: false,
      sortable: false,
      visible: true,
      width: 100,
    },
    {
      Header: 'Pay Date',
      accessor: 'paidDate',
      resizable: false,
      sortable: false,
      visible: true,
      width: 70,
    },
    {
      Header: 'Select',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      width: 50,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      width: 20,
    },
  ]
};

export const depreciationAdjustmentList: TableSettings = {
  tableVersion: 1009,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    {
      accessor: 'postdate',
      Header: 'Adjust Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'branch',
      Header: 'BR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'vendorname',
      Header: 'Vendor',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'gldescription',
      Header: 'Account Name',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'decription',
      Header: 'Description',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const depreciationAdjustmentTable: TableSettings = {
    tableVersion: 10048,
    overflowX: 'hidden',
    overflowY: 'scroll',
    height: '525px',
    flexResizer: true,
    columns: [
        {
            Header: '#',
            accessor: 'indicator',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 2.63,
        },
        {
            Header: 'Account Code',
            accessor: 'glDescription',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 17.54,
        },
        {
            Header: 'BR',
            accessor: 'branch',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 5.26,
        },
        {
            Header: 'Description',
            accessor: 'description',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 41.23,
        },
        {
            Header: 'Expense',
            accessor: 'expense',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 10.53,
        },
        {
            Header: 'Balance',
            accessor: 'balance',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 10.53,
        },
        {
            Header: 'Depreciation Amount',
            accessor: 'adjustmentAmount',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 10.53,
        },
        {
            Header: '',
            accessor: 'scroll',
            resizable: false,
            sortable: false,
            visible: true,
            initialWidthPercentage: 1.75,
        },
    ]
};

export const amortizationAdjustmentList: TableSettings = {
  tableVersion: 1010,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    {
      accessor: 'postdate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'branch',
      Header: 'BR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'vendorName',
      Header: 'Vendor',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'accountName',
      Header: 'Account Name',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const amortizationAdjustmentTable: TableSettings = {
  tableVersion: 10050,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '525px',
  flexResizer: true,
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Account Code',
      accessor: 'glDescription',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.54,
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 41.23,
    },
    {
      Header: 'Expense',
      accessor: 'expense',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: 'Amortization Amount',
      accessor: 'adjustmentAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.53,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};

export const badDebtProcessingList: TableSettings = {
  tableVersion: 1010,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    {
      accessor: 'postdate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'entity',
      Header: 'Entity',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'currency',
      Header: 'CUR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const badDebtProcessingTable: TableSettings = {
  tableVersion: 1015,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '525px',
  flexResizer: false,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Date',
      accessor: 'paymentDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'Entity',
      accessor: 'entityName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.56,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 50,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.77,
    },
    {
      Header: 'Select',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};

export const salesTaxReturnTable: TableSettings = {
  tableVersion: 1012,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '400px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3,
    },
    {
      Header: 'Date',
      accessor: 'invoiceDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9,
    },
    {
      Header: 'Entity',
      accessor: 'entityName',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 38,
    },
    {
      Header: 'Invoice/Bill/CrDb #',
      accessor: 'invoiceNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18,
    },
    {
      Header: 'Type',
      accessor: 'type',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5,
    },
    {
      Header: 'Recovered Amount',
      accessor: 'receivedAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
    {
      Header: 'Paid Amount',
      accessor: 'paidAmount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10,
    },
    {
      Header: 'Select',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.25,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};


export const distributionPayableList: TableSettings = {
  tableVersion: 1005,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'postDate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'distTo',
      Header: 'Distribution To',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'description',
      Header: 'Description',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'paid',
      Header: 'Paid',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
     {
      accessor: 'u1Date',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
   
  ]
};

export const distributionPayableTable: TableSettings = {
  tableVersion: 1008,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '102px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3,
    },
   {
      Header: 'Billing Code *',
      accessor: 'billingCode',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 31.75,
    },
    {
      Header: 'Item Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 51.5,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.75,
    },
  ]
};



export const accountingJournalList: TableSettings = {
  tableVersion: 10046,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    // { accessor: 'status', Header: 'S', visible: true, width: 30, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    // { accessor: 'type', Header: 'Type', visible: true, width: 40, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'postDate', Header: 'Date', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date'},
    // { accessor: 'branch', Header: 'BR', visible: true, width: 40, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'seq', Header: 'Seq', visible: true, width: 60, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'entity', Header: 'Entity', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    // { accessor: 'description', Header: 'Description', visible: true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'remark', Header: 'Remark', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'accountNo', Header: 'Account No', visible: true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'subCode', Header: 'Sub Code', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'currency', Header: 'CUR', visible: true, width: 40, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
    // { accessor: 'fDebit', Header: 'Debit', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'fCredit', Header: 'Credit', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'exRate', Header: 'Ex. Rate', visible: true, width: 60, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'debit', Header: 'Debit (USD)', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'credit', Header: 'Credit (USD)', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'jourType', Header: 'Journal Type', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'float'},
    // { accessor: 'updateDate', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date'},
    // { accessor: 'updateBy', Header: 'Update by', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text'},
  ]
};

export const journalTable: TableSettings = {
  tableVersion: 10050,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '400px',
  flexResizer: true,

  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.63, },
    { Header: 'Account Code', accessor: 'glFull', resizable: false, sortable: false, visible: true, initialWidthPercentage: 14.03, },
    { Header: 'Sub Code', accessor: 'subCode', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.01, },
    { Header: 'Ent.Type', accessor: 'comType', resizable: false, sortable: false, visible: true, initialWidthPercentage: 6.64, },
    { Header: 'Transaction Entity (Customer)', accessor: 'comName', resizable: false, sortable: false, visible: true, initialWidthPercentage: 13.15, },
    { Header: 'Description', accessor: 'mDesc', resizable: true, sortable: false, visible: true, initialWidthPercentage: 16.17, },
    { Header: 'CUR', accessor: 'currency', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.5, },
    { Header: 'Debit', accessor: 'fDebit', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.01, },
    { Header: 'Credit', accessor: 'fCredit', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.01, },
    { Header: 'Ex. Rate', accessor: 'exRate', resizable: false, sortable: false, visible: true, initialWidthPercentage: 6.0, },
    { Header: 'Debit (USD)', accessor: 'debit', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.01, },
    { Header: 'Credit (USD)', accessor: 'credit', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.01, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 1.75, },
  ]
};

export const undoDepositClearTable: TableSettings = {
  tableVersion: 10041,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,
  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Clear Date', accessor: 'depositDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Type', accessor: 'type', resizable: false, sortable: true, visible: true, initialWidthPercentage: 4.04, },
    { Header: 'Customer', accessor: 'customerName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 14.10, },
    { Header: 'Received From', accessor: 'receivedFromName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 14.10, },
    { Header: 'Check #', accessor: 'checkNo', resizable: false, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'CUR', accessor: 'currency', resizable: false, sortable: true, visible: true, initialWidthPercentage: 5.12, },
    { Header: 'Items', accessor: 'items', resizable: false, sortable: true, visible: true, initialWidthPercentage: 3.69, },
    { Header: 'Amount', accessor: 'amount', resizable: false, sortable: true, visible: true, initialWidthPercentage: 11.53, },
    { Header: 'Undo', accessor: 'isSelected', resizable: false, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const cancelCheckClearTable: TableSettings = {
  tableVersion: 10041,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,
  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Clear Date', accessor: 'depositDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Type', accessor: 'type', resizable: false, sortable: true, visible: true, initialWidthPercentage: 4.04, },
    { Header: 'Vendor', accessor: 'customerName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 14.10, },
    { Header: 'Pay To', accessor: 'receivedFromName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 14.10, },
    { Header: 'Check #', accessor: 'checkNo', resizable: false, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'CUR', accessor: 'currency', resizable: false, sortable: true, visible: true, initialWidthPercentage: 5.12, },
    { Header: 'Items', accessor: 'items', resizable: false, sortable: true, visible: true, initialWidthPercentage: 3.69, },
    { Header: 'Amount', accessor: 'amount', resizable: false, sortable: true,visible: true,  initialWidthPercentage: 11.53, },
    { Header: 'Clear', accessor: 'isSelected', resizable: false, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const cancelCreditCardClearTable: TableSettings = {
  tableVersion: 10040,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,
  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'CC Clear Date', accessor: 'depositDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'Vendor', accessor: 'vendorName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 20.51, },
    { Header: 'CC Ref. #', accessor: 'ccRefNo', resizable: false, sortable: true, visible: true, initialWidthPercentage: 14.10, }, 
    { Header: 'CUR', accessor: 'currency', resizable: false, sortable: true, visible: true, initialWidthPercentage: 5.12, }, 
    { Header: 'Items', accessor: 'items', resizable: false, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: 'Amount', accessor: 'amount', resizable: false, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'Cancel', accessor: 'isSelected', resizable: false, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const checkClearWithExcelTable: TableSettings = {
  tableVersion: 10013,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '381px',
  useStorage: true,
  flexResizer: true,
  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.84, },
    { Header: 'Bank Date', accessor: 'bankDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Check #', accessor: 'checkNo', resizable: false, sortable: true, visible: true, initialWidthPercentage: 12.82, },
    { Header: 'Bank Amount', accessor: 'bankAmount', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Accrual Date', accessor: 'accrualDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Deposit Date', accessor: 'depositDate', resizable: false, sortable: true, visible: true, initialWidthPercentage: 10.25, },
    { Header: 'Pay To', accessor: 'receivedFromName', resizable: false, sortable: true, visible: true, initialWidthPercentage: 20.51, },
    { Header: 'Amount', accessor: 'amount', resizable: false, sortable: true, visible: true, initialWidthPercentage: 11.53, },
    { Header: 'Confirm', accessor: 'isSelected', resizable: false, sortable: true, visible: true, initialWidthPercentage: 7.69, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.56, },
  ]
};

export const paymentToolList: TableSettings = {
  tableVersion: 1047,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '221px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: 'Date',
      accessor: 'postDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.3,
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.15,
    },
    {
      Header: 'Bill #',
      accessor: 'invNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.14,
    },
    {
      Header: 'Customer',
      accessor: 'entityName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 7.37,
    },
    {
      Header: 'Ref. #',
      accessor: 'refNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.14,
    },
    {
      Header: 'B/L #',
      accessor: 'hblNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.14,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.96,
    },
    {
      Header: `AR (Bill)`,
      accessor: 'billAmtAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: 'AR (Due)',
      accessor: 'dueAmtAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: '',
      accessor: 'isSelectAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: 'AP (Bill)',
      accessor: 'billAmtAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: 'AP (Due)',
      accessor: 'dueAmtAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: '',
      accessor: 'isSelectAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: 'Duty AR (Bill)',
      accessor: 'billAmtDutyAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: 'Duty AR (Due)',
      accessor: 'dueAmtDutyAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: '',
      accessor: 'isSelectDutyAR',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: 'Duty AP (Bill)',
      accessor: 'billAmtDutyAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: 'Duty AP (Due)',
      accessor: 'dueAmtDutyAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.91,
    },
    {
      Header: '',
      accessor: 'isSelectDutyAP',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: 'Bill Amount',
      accessor: 'invAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.22,
    },
    {
      Header: 'Due Amount',
      accessor: 'dueAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.22,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.22,
    },
    {
      Header: '',
      accessor: 'isSelect',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.53,
    },
  ]
};

export const periodLoadStorageItem :TableSettings = {
  tableVersion: 10043,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: true,

  alternateRows: false,
  columns: [
    {
      Header: 'Select',
      accessor: 'select',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Product Code / SKU',
      accessor: 'itemNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 40.27,
    },
    {
      Header: 'Unit',
      accessor: 'unit',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.23,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.23,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13.23,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.40,
    },
  ]
};

export const emailOptionItem: TableSettings = {
  tableVersion: 1011,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '300px',
  flexResizer: true,

  columns: [
    {
      Header: 'Email',
      accessor: 'email',
      resizable: true,
      sortable: false,
      visible: true,
      width: 650,
    },
    {
      Header: 'Select',
      accessor: 'select',
      resizable: true,
      sortable: false,
      visible: true,
      width: 40,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: true,
      sortable: false,
      visible: true,
      width: 30,
    },
  ]
};



export const autoBillingDetailTable: TableSettings = {
  tableVersion: 1011,
  overflowX: 'hidden',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '150px',
  flexResizer: true,

  columns: [
    {
      Header: '',
      accessor: 'selected',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.09,
    },
    {
      Header: 'Company Name',
      accessor: 'companyName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 23.24,
    },
    {
      Header: 'Billing Code',
      accessor: 'billingCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.00,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: 'Last Amount',
      accessor: 'lastAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: 'A/R',
      accessor: 'ar',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: 'Inv. Seq',
      accessor: 'invoiceSeq',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.12,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.94,
    },
  ]
};



export const autoInvoiceDetailTable: TableSettings = {
  tableVersion: 1011,
  overflowX: 'hidden',
  overflowY: 'scroll',
  showNewRowPlaceholder: false,
  height: '150px',
  flexResizer: true,

  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.09,
    },
    {
      Header: 'Customer',
      accessor: 'companyName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 50.76,
    },
    {
      Header: 'Invoice Seq',
      accessor: 'invoiceSeq',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.74,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.74,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.94,
    },
  ]
};

export const advanceSalesList: TableSettings = {
  tableVersion: 1000,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: [
    {
      accessor: 'status',
      Header: 'S',
      visible: true,
      width: 30,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    // {
    //   accessor: 'void',
    //   Header: 'V',
    //   visible: true,
    //   width: 40,
    //   canBeHidden: true,
    //   resizable: true,
    //   sortable: true,
    //   filterable: true,
    //   filterType: 'text'
    // },
    {
      accessor: 'postdate',
      Header: 'Date',
      visible: true,
      width: 75,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'branch',
      Header: 'BR',
      visible: true,
      width: 40,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'vendorname',
      Header: 'Vendor',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'gldescription',
      Header: 'Account Name',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'decription',
      Header: 'Description',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'amount',
      Header: 'Amount',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'float'
    },
    {
      accessor: 'remark',
      Header: 'Remark',
      visible: true,
      width: 150,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u2Date',
      Header: 'Update',
      visible: true,
      width: 100,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'date'
    },
    {
      accessor: 'u2ID',
      Header: 'Update by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
    {
      accessor: 'u1ID',
      Header: 'Create by',
      visible: true,
      width: 80,
      canBeHidden: true,
      resizable: true,
      sortable: true,
      filterable: true,
      filterType: 'text'
    },
  ]
};

export const advanceSalesTable: TableSettings = {
  tableVersion: 1005,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '200px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.63,
    },
    {
      Header: 'Date',
      accessor: 'postDate',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8,
    },
    {
      Header: 'Account Code',
      accessor: 'glDescription',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.54,
    },
    {
      Header: 'BR',
      accessor: 'branch',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5.26,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Balance',
      accessor: 'expense',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.64,
    },
    {
      Header: 'New Account Code',
      accessor: 'glDescription2',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.54,
    },
    {
      Header: 'Description',
      accessor: 'description2',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.64,
    },
   {
     Header: '',
     accessor: 'scroll',
       resizable: false,
       sortable: false,
       visible: true,
       initialWidthPercentage: 1.75,
    },
  ]
};

export const batchPrintHistoryList: TableSettings = {
  tableVersion: 1001,
  overflowX: 'scroll',
  overflowY: 'scroll',
 
  height: '100%',
  flexResizer: false,
 
  alternateRows: true,
  columns: []
};
 